module.exports = __webpack_public_path__ + "img/close.6dd59435.svg";